import Vue from 'vue';
import assign from 'lodash/assign';

class StorageService
{
    static uploadUrl = () => `${Vue.axios.defaults.baseURL}/admin/storage/upload`;

    static async upload(file, container = "")
    {
        let data = new FormData();
        data.append('container', container);
        data.append('file', file.upload);

        let result = await Vue.axios.post('admin/storage/upload', data);

        return result.data;
    }

    static async getResources(scope, folder, filter, all, pager)
    {
        let data = pager.data();

        assign(data, {
            scope: scope,
            folder: folder,
            filter: filter,
            all: all
        });

        return Vue.axios.get(`admin/storage/resources`, {
            params: data
        });
    }

    static getFolders(items)
    {
        return items
            .filter(function(item)
            {
                return item.resourceType === 'folder';
            })
            .map(function(item)
            {
                return item.id;
            });
    }

    static getFiles(items)
    {
        return items
            .filter(function(item)
            {
                return item.resourceType === 'file';
            })
            .map(function(item)
            {
                return item.id;
            });
    }

    static async deleteResources(items)
    {
        let folders = StorageService.getFolders(items);
        let files = StorageService.getFiles(items);

        return Vue.axios.delete(`admin/storage/resources`, {
            params: {
                folders: folders.join(','),
                files: files.join(',')
            }
        });
    }

    static async moveResources(destination, items)
    {
        let folders = StorageService.getFolders(items);
        let files = StorageService.getFiles(items);

        return Vue.axios.put(`admin/storage/resources/move`, {
            destination: destination,
            folders: folders,
            files: files
        });
    }

    static async createFolder(model)
    {
        return Vue.axios.post(`admin/storage/folders`, model);
    }

    static async renameFolder(id, name)
    {
        return Vue.axios.put(`admin/storage/folders/${id}/rename`, { folderName: name });
    }

    static async renameFile(id, name)
    {
        return Vue.axios.put(`admin/storage/files/${id}/rename`, { fileName: name });
    }

    static async saveContent(id, model)
    {
        return Vue.axios.put(`admin/storage/files/${id}/content`, { content: JSON.stringify(model) });
    }

    static async cropImage(id, model)
    {
        return Vue.axios.post(`admin/storage/files/${id}/crop`, model);
    }

    static async resizeImage(id, model)
    {
        return Vue.axios.post(`admin/storage/files/${id}/resize`, model);
    }
}

export default StorageService;
